import { includes } from '@edicom/common/string/includes';
import { accentFold } from '@edicom/common/string/accentFold';
import { indexOf } from '@edicom/common/string/indexOf';
import { filter } from '@edicom/common/string/filter';
import { htmlEscape } from '@edicom/common/string/htmlEscape';

/**
 * Devolvemos funciones útiles para filtros y búsquedas con cadenas
 *
 * @returns
 */
export default function ecStringService() {
  return function(str = '', options = {}) {
    return {
      accentFold: query => accentFold(str, query, options),
      indexOf: query => indexOf(str, query, options),
      includes: query => includes(str, query, options),
      filter: query => filter(str, query, options),
      escape: () => htmlEscape(str),
    };
  };
}
